export { SchoolCollectionFragment } from './school-collection';
export { SchoolSingleFragment } from './school-single';
